import React from 'react';
import { Drawer, Box, Typography, List, ListItemButton, ListItemText, Collapse, Divider } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

export default function CatalogDrawer({
                                          open, onClose, catalog, loading, error,
                                          onSelectCategory, onSelectSubCategory,
                                          selectedCategoryId, selectedSubCategoryId
                                      }) {
    const [openMap, setOpenMap] = React.useState({});
    const toggle = (id) => setOpenMap((m) => ({ ...m, [id]: !m[id] }));

    const cats = catalog?.categories || [];

    return (
        <Drawer anchor="left" open={open} onClose={onClose}>
            <Box sx={{ width: 300, p: 2 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>Katalog</Typography>
                <Divider sx={{ mb: 1 }} />

                {loading ? (
                    <Typography variant="body2">Yuklanmoqda...</Typography>
                ) : cats.length > 0 ? (
                    <List dense>
                        {cats.map(cat => {
                            const expanded = !!openMap[cat.id];
                            const active = selectedCategoryId === cat.id && !selectedSubCategoryId;

                            return (
                                <React.Fragment key={cat.id}>
                                    <ListItemButton
                                        selected={active}
                                        onClick={() => { onSelectCategory(cat.id); toggle(cat.id); }}
                                    >
                                        <ListItemText
                                            primary={cat.name}
                                            secondary={cat.featured ? 'Featured' : undefined}
                                        />
                                        {expanded ? <ExpandLess /> : <ExpandMore />}
                                    </ListItemButton>

                                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            {/* 🔹 “Barchasi” – shu kategoriya bo‘yicha hammasi */}
                                            <ListItemButton
                                                key={`${cat.id}__ALL`}
                                                sx={{ pl: 4 }}
                                                selected={selectedCategoryId === cat.id && !selectedSubCategoryId}
                                                onClick={() => onSelectCategory(cat.id)}   // subni reset qilamiz
                                            >
                                                <ListItemText primary="Barchasi" />
                                            </ListItemButton>

                                            {/* 🔹 SubCategory lar */}
                                            {(cat.subCategories || []).map(sub => (
                                                <ListItemButton
                                                    key={sub.id}
                                                    sx={{ pl: 4 }}
                                                    selected={selectedSubCategoryId === sub.id}
                                                    onClick={() => onSelectSubCategory(cat.id, sub.id)}
                                                >
                                                    <ListItemText primary={sub.name} />
                                                </ListItemButton>
                                            ))}
                                        </List>
                                    </Collapse>
                                </React.Fragment>
                            );
                        })}
                    </List>

                ) : error ? (
                    <Typography variant="body2" color="error">
                        Katalogni olishda xatolik{error?.message ? `: ${error.message}` : ''}
                    </Typography>
                ) : (
                    <Typography variant="body2">Kategoriya topilmadi</Typography>
                )}

            </Box>
        </Drawer>
    );
}
